import { render } from "./PhoneInputVertical.vue?vue&type=template&id=4f8d732f"
import script from "./PhoneInputVertical.vue?vue&type=script&lang=js"
export * from "./PhoneInputVertical.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hub.disinfo.eu/releases/81973855/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__